// Utility to convert sport names to the correct capitalized format
export const normalizeSportName = (sport: string): string => {
  const sportMapping: { [key: string]: string } = {
    'football': 'Football',
    'cricket': 'Cricket',
    'tennis': 'Tennis',
    'chess': 'Chess',
    'basketball': 'Basketball',
    'swimming': 'Swimming',
    'badminton': 'Badminton',
    'athletics': 'Athletics',
    'volleyball': 'Volleyball',
    'hockey': 'Hockey',
    'boxing': 'Boxing',
    'wrestling': 'Wrestling',
    'gymnastics': 'Gymnastics',
    'cycling': 'Cycling',
    'general': 'General'
  };

  // If it's already capitalized, return as is
  if (sport && sport[0] === sport[0].toUpperCase()) {
    return sport;
  }

  // Convert lowercase to capitalized
  return sportMapping[sport.toLowerCase()] || 'General';
};

export const normalizeUserSports = (sports: string[]): string[] => {
  return sports.map(sport => normalizeSportName(sport));
};

export const getSportIcon = (sport: string): string => {
  if (!sport) return '🏆';
  const sportLower = sport.toLowerCase();
  if (sportLower.includes('football')) return '⚽';
  if (sportLower.includes('cricket')) return '🏏';
  if (sportLower.includes('tennis')) return '🎾';
  if (sportLower.includes('chess')) return '♟️';
  if (sportLower.includes('basketball')) return '🏀';
  if (sportLower.includes('swimming')) return '🏊';
  if (sportLower.includes('badminton')) return '🏸';
  if (sportLower.includes('athletics') || sportLower.includes('running')) return '🏃';
  if (sportLower.includes('volleyball')) return '🏐';
  if (sportLower.includes('hockey')) return '🏑';
  if (sportLower.includes('boxing')) return '🥊';
  if (sportLower.includes('wrestling')) return '🤼';
  if (sportLower.includes('gymnastics')) return '🤸';
  if (sportLower.includes('cycling')) return '🚴';
  if (sportLower.includes('kabaddi')) return '💪';
  return '🏆';
};